module.exports = __webpack_public_path__ + "static/media/1.7eccda52.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/11779/1.jpg
// module id = 431
// module chunks = 0